import { type MarkdownData } from '@atlassian/conversation-assistant-content-transformer/utils/stream-markdown-parser';
import { type StreamAnswerPart } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { addAnswerPart as serviceAddAnswerPart } from '@atlassian/conversation-assistant-service/services/assistance-service/utils/data';
import {
	type StoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { updateStoreAssistant } from './updateStoreAssistant';

export const addAnswerPartWithMarkdownData = ({
	chat,
	answerId,
	answerPart,
	markdownData,
	useIndex,
}: {
	chat: StoreChatItem[];
	answerId: string;
	answerPart: StreamAnswerPart;
	markdownData: MarkdownData;
	useIndex?: number;
}): StoreChatItem[] => {
	const { key, content, loading } = markdownData;
	const loadingKey = `${key}-loading`;

	return updateStoreAssistant({
		chat,
		promptId: answerId,
		updateFunction: (storeAssistant): StoreAssistant => ({
			...storeAssistant,
			content: {
				...serviceAddAnswerPart(storeAssistant.content, answerPart),
				streamingComplete: false,
			},
			markdownData: {
				...storeAssistant.markdownData,
				[key]: (storeAssistant.markdownData?.[key] || '') + content,
				[loadingKey]: loading ? 'true' : 'false',
			},
		}),
		updateType: 'Add Answer Part With Markdown Data',
		useIndex,
	});
};
